import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from 'src/app/services/language.service';
import { TranslationService } from 'src/app/services/translation.service';

@Pipe({
    name: 'translate',
    standalone: false
})

export class TranslatePipe implements PipeTransform {
  constructor(private translationService: TranslationService, private langservice: LanguageService, private http: HttpClient) {}

  transform(value: string, translations: any): string {

    if (!value || !translations) {
      return value;
    }

    const translatedText = translations[value];
    if (!translatedText) {
      return value;
    }

    return translatedText;
  }

}
